import {AfterContentInit, Component, Input, TemplateRef, ViewChild} from '@angular/core';

@Component({
    selector: 'lib-rc-table-row-extension',
    template: `<ng-template #rowExtension>
    <div class="rc-table-row-extension">
        <ng-content></ng-content>
    </div>
</ng-template>
`,
    styles: [``]
})
export class RcTableRowExtensionComponent implements AfterContentInit {
    @Input() rowData: any = {};

    @ViewChild('rowExtension', {read: TemplateRef}) rowExtension;

    ngAfterContentInit() {

    }

}
